import type { HashtagResponseAuth } from './hashtagResponseAuth';
import type { HashtagResponseBasicInfo } from './hashtagResponseBasicInfo';
import type { HashtagResponseStats } from './hashtagResponseStats';

export interface HashtagResponse {
  /** 인증 컨텍스트 정보 */
  auth?: HashtagResponseAuth;
  /** 해시태그 기본 정보 */
  basicInfo?: HashtagResponseBasicInfo;
  /** 해시태그 통계 정보 */
  stats?: HashtagResponseStats;
}
